import React from 'react';
import { fmtInches } from './InchesInput';

const TEAL = '#0D9488', INK = '#475569';

// Esquema das janelas internas de Bay/Bow lado a lado (largura proporcional) com tipo e L × A. compact = só os quadros.
export const BayBowDiagram = ({ components = [], width = 240, height = 120, compact = false, className = '', testId }) => {
  const comps = components.filter((c) => Number(c.width) > 0 && Number(c.height) > 0);
  if (!comps.length) return null;
  const gap = compact ? 1 : 3, padX = compact ? 2 : 8, padB = compact ? 2 : 16, padT = compact ? 2 : 6;
  const totalW = comps.reduce((n, c) => n + Number(c.width), 0);
  const maxH = Math.max(...comps.map((c) => Number(c.height)));
  const s = Math.min((width - padX * 2 - gap * (comps.length - 1)) / totalW, (height - padB - padT) / maxH);
  let x = (width - (totalW * s + gap * (comps.length - 1))) / 2;
  const fs = Math.max(7, Math.min(11, width / 22));
  return (
    <svg viewBox={`0 0 ${width} ${height}`} width={width} height={height} className={className} data-testid={testId} role="img">
      {comps.map((c, i) => {
        const w = Number(c.width) * s, h = Number(c.height) * s;
        const y = height - padB - h - (maxH * s - h) / 2;
        const el = (
          <g key={i} data-testid={testId ? `${testId}-panel-${i}` : undefined}>
            <rect x={x} y={y} width={w} height={h} fill="rgba(13,148,136,0.10)" stroke={TEAL} strokeWidth={compact ? 1 : 1.5} />
            {c.type === 'DH' && <line x1={x} y1={y + h / 2} x2={x + w} y2={y + h / 2} stroke={TEAL} strokeWidth="1" />}
            {!compact && <text x={x + w / 2} y={y + h / 2 - 1} fontSize={fs} fontWeight="700" fill={INK} textAnchor="middle" fontFamily="ui-monospace, monospace">{c.type}</text>}
            {!compact && <text x={x + w / 2} y={y + h / 2 + fs} fontSize={fs - 1} fill={INK} textAnchor="middle" fontFamily="ui-monospace, monospace">{fmtInches(c.width)}×{fmtInches(c.height)}</text>}
          </g>
        );
        x += w + gap;
        return el;
      })}
      {!compact && <text x={width / 2} y={height - 3} fontSize={fs - 1} fontWeight="700" fill={TEAL} textAnchor="middle" fontFamily="ui-monospace, monospace">{comps.map((c) => c.type).join(' + ')} · {fmtInches(totalW)}"</text>}
    </svg>
  );
};
